import {
    CreateTemplateType,
    FileTemplatePanel
} from '~/components/Templates/types/templates.types';

export const ANGULAR_TEMPLATE_KEYS: Partial<
    Record<CreateTemplateType, { name: string; angularKey: string }>
> = {
    [CreateTemplateType.Emails]: { name: 'Email', angularKey: 'email' },
    [CreateTemplateType.Packages]: {
        name: 'Package',
        angularKey: 'package'
    },
    [CreateTemplateType.Contact_forms]: {
        name: 'Contact form',
        angularKey: 'contactForm'
    },
    [CreateTemplateType.Gift_cards]: {
        name: 'Gift card',
        angularKey: 'giftCard'
    },
    [CreateTemplateType.LegacyBrochure]: {
        name: 'Brochure',
        angularKey: 'brochure'
    },
    [CreateTemplateType.LegacyInvoice]: {
        name: 'Invoice',
        angularKey: 'invoice'
    },
    [CreateTemplateType.LegacyProposal]: {
        name: 'Proposal',
        angularKey: 'proposal'
    },
    [CreateTemplateType.LegacyQuestionnaire]: {
        name: 'Questionnaire',
        angularKey: 'questionnaire'
    },
    [CreateTemplateType.LegacyContract]: {
        name: 'Agreement',
        angularKey: 'agreement'
    },
    [CreateTemplateType.Blocks]: { name: 'Block', angularKey: 'flow' }
};

export const PANEL_TO_CREATE_TEMPLATE_TYPE: Partial<
    Record<FileTemplatePanel, CreateTemplateType>
> = {
    [FileTemplatePanel.Emails]: CreateTemplateType.Emails,
    [FileTemplatePanel.Packages]: CreateTemplateType.Packages,
    [FileTemplatePanel.Contact_forms]: CreateTemplateType.Contact_forms,
    [FileTemplatePanel.Gift_cards]: CreateTemplateType.Gift_cards,
    [FileTemplatePanel.Brochures]: CreateTemplateType.LegacyBrochure,
    [FileTemplatePanel.Invoices]: CreateTemplateType.LegacyInvoice,
    [FileTemplatePanel.Proposals]: CreateTemplateType.LegacyProposal,
    [FileTemplatePanel.Questionnaires]: CreateTemplateType.LegacyQuestionnaire,
    [FileTemplatePanel.Agreements]: CreateTemplateType.LegacyContract,
    [FileTemplatePanel.Blocks]: CreateTemplateType.Blocks
};
